import wujiFetch from '@utils/wujiFetch';
import { runtimePath, designPath } from '@/config/constant';
const getHostConfigList = async (projectId, isRuntime) => await wujiFetch(`${isRuntime ? runtimePath : designPath}/hostconfig/list?projectid=${projectId}`);
const getHostList = async (projectId) => await wujiFetch(`${designPath}/hostconfig/hosts?projectid=${projectId}`);
const deleteHostConfig = async (projectId, id, headers = {}) => await wujiFetch(`${designPath}/hostconfig/${id}?projectid=${projectId}`, {
    method: 'DELETE',
    headers,
});
const createHostConfig = async (projectId, data, headers = {}) => await wujiFetch(`${designPath}/hostconfig?projectid=${projectId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers,
});
const updateHostConfig = async (projectId, id, data, headers = {}) => await wujiFetch(`${designPath}/hostconfig/${id}?projectid=${projectId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers,
});
/** 查询指定域名是否已录入 OA Token，返回 taiPaasId 与 isTokenExist */
const oaTokenIsExist = async (projectId, domain) => await wujiFetch(`${designPath}/hostconfig/oatoken/isExist?projectid=${projectId}&domain=${encodeURIComponent(domain)}`);
/** 录入指定域名的 OA Token（仅可写入一次） */
const oaTokenUpdate = async (projectId, domain, token, headers = {}) => await wujiFetch(`${designPath}/hostconfig/oatoken/update?projectid=${projectId}`, {
    method: 'POST',
    body: JSON.stringify({ domain, token }),
    headers,
});
const domainIsExist = async (domain) => await wujiFetch(`${designPath}/hostconfig/domain/isExist?domain=${encodeURIComponent(domain)}`);
export default {
    getHostConfigList,
    getHostList,
    deleteHostConfig,
    createHostConfig,
    updateHostConfig,
    oaTokenIsExist,
    oaTokenUpdate,
    domainIsExist,
};
